import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Marquee from '../components/Marquee';
import CTABand from '../components/CTABand';
import WhyUs from '../components/WhyUs';
import Process from '../components/Process';
import Comparison from '../components/Comparison';
import CourseComparison from '../components/CourseComparison';
import Scholarship from '../components/Scholarship';
import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import FAQ from '../components/FAQ';
import Team from '../components/Team';
import Footer from '../components/Footer';
import CompanyLogos from '../components/CompanyLogos';

const Home = () => {
  return (
    <div className="font-body bg-paper text-[#1c1c1c]">
      <Navbar />
      <Hero />
      <CompanyLogos />
      <Services />
      <Marquee />
      <Scholarship />
      <CTABand />
      <WhyUs />
      <Process />
      <CourseComparison />
      <Comparison />
      <Testimonials />
      <Blog />
      <FAQ />
      <Team />
      <Footer />
    </div>
  );
};

export default Home;
